import posthog from 'posthog-js'
import { IS_PROD } from 'constants/envs'

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  ui_host: 'https://eu.posthog.com',
  defaults: '2025-05-24',
  person_profiles: 'always',
  // capture_exceptions: true, // This enables capturing exceptions using Error Tracking
  debug: !IS_PROD && process.env.NEXT_PUBLIC_POSTHOG_DEBUG === 'true'
})
